import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavigationType } from '@shared-libs/enums';
import { UserManager } from '@shared-managers/user.manager';
import { AuthenticationService } from '@shared-services/authentication.service';
import { NavigationService } from '@shared-services/navigation.service';
import { BasePage } from '@shared-pages/base.page';

@Component({
	selector: 'landing-page',
	templateUrl: 'landing.page.html',
	styleUrls: ['landing.page.scss'],
})
export class LandingPage extends BasePage implements OnInit {
	constructor(
		private readonly route: ActivatedRoute,
		public readonly authenticationService: AuthenticationService,
		private readonly navigationService: NavigationService,
		private readonly userManager: UserManager
	) {
		super();
	}

	public ngOnInit(): void {
		void this.initialize();
		this.route.url.subscribe(() => {
			void this.initialize();
		});
	}

	public navigateToRegisterTenant(): void {
		void this.navigationService.navigateTo(NavigationType.page, '/digibank-registreren').catch();
	}

	public navigateToLogin(): void {
		void this.navigationService.navigateTo(NavigationType.page, '/login').catch();
	}

	public navigateToPublicPage(): void {
		void this.navigationService.navigateTo(NavigationType.page, '/activiteiten').catch();
	}

	private async initialize(): Promise<void> {}
}
